module.exports = __webpack_public_path__ + "static/logos-5769b09c20db9b3acb0d4536cb4bfa86.svg";